import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

import SpokePage from "./SpokePage";
import { Star } from "./Star";
import { FEATURED_SECTORS, ALL_SECTORS_LIST, SECTOR_COUNT } from "../../lib/adelContent";
import { cld } from "../../lib/cloudinary";

import "../preview/Design13.css";
import "../preview/Design13Audience.css";
import "./Editorial.css";

/* Dedicated page: /candidates/sectors — the featured bento + full sector index. */
export default function CandidateSectorsPage() {
  return (
    <SpokePage
      audience="candidate"
      eyebrow="Where you could work"
      title={<>Real roles, <em>across many trades.</em></>}
      intro="Welding, hospitality, caregiving, driving, security and dozens more — real jobs with real employers abroad, matched to what you already know how to do."
      next={{ label: "Read real stories", to: "/candidates/stories" }}
    >
      {/* FEATURED SECTORS — bento */}
      <section className="ed-band ed-band--cream ed-pad">
        <div className="ed-container">
          <div className="d13-sectors__grid">
            {FEATURED_SECTORS.map((s, i) => (
              <motion.a
                key={s.slug}
                href={`/sectors/${s.slug}`}
                className={`d13-sector d13-sector--${s.size}`}
                initial={{ opacity: 0, y: 18 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.2 }}
                transition={{ duration: 0.55, delay: i * 0.05 }}
              >
                <img
                  src={cld(`adel/v2/sector-${s.slug}`, { w: 1200, q: "auto", f: "auto" })}
                  srcSet={`${cld(`adel/v2/sector-${s.slug}`, { w: 600 })} 600w, ${cld(`adel/v2/sector-${s.slug}`, { w: 1200 })} 1200w`}
                  sizes="(max-width: 1024px) 100vw, 50vw"
                  loading="lazy"
                  alt=""
                />
                <div className="d13-sector__veil" />
                <div className="d13-sector__meta"><span>Sector</span><h3>{s.name}</h3></div>
                <span className="d13-sector__arrow"><ArrowUpRight size={18} /></span>
              </motion.a>
            ))}
          </div>
        </div>
      </section>

      {/* ALL SECTORS — plain index, so the full breadth shows */}
      <section className="ed-band ed-band--cream ed-pad">
        <div className="ed-container">
          <header className="ed-opener">
            <div className="ed-opener__row">
              <span className="ed-eyebrow"><Star className="ed-eyebrow__star" /> All {SECTOR_COUNT} sectors</span>
            </div>
          </header>
          <ul style={{ display: "flex", flexWrap: "wrap", gap: "12px 28px", listStyle: "none", padding: 0, margin: "28px 0 0" }}>
            {ALL_SECTORS_LIST.map((s) => (
              <li key={s.slug}>
                <Link to={`/sectors/${s.slug}`} className="d13-sectors__all">{s.name}</Link>
              </li>
            ))}
          </ul>
        </div>
      </section>
    </SpokePage>
  );
}
